import script from "./InformationScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationScreen.vue?vue&type=script&setup=true&lang=js"

import "./InformationScreen.vue?vue&type=style&index=0&id=7933b02e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7933b02e"]])

export default __exports__